"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.watchCreator = watchCreator;
var _actions = require("../../actions");
var _utils = require("../../utils");
function watchCreator(getState, dispatch) {
  return inputNames => {
    const {
      formElement,
      inputStates
    } = getState();
    dispatch((0, _actions.addWatchedNames)(inputNames));
    return (0, _utils.getWatchedValues)(formElement, inputStates, inputNames);
  };
}